import { cn } from "@artisan/ui";
import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";

/** A page inside the shell: title row, optional back link and actions. */
export function Screen({
  title,
  subtitle,
  back,
  actions,
  children,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  back?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mx-auto max-w-[1180px] px-8 pt-7 pb-12", className)}>
      <header className="mb-6 flex items-start gap-4">
        {back ? (
          <Link
            to={back}
            aria-label="Буцах"
            className="mt-1 grid size-11 shrink-0 place-items-center rounded-full border bg-card shadow-xs hover:bg-accent"
          >
            <ChevronLeft className="size-5" aria-hidden />
          </Link>
        ) : null}
        <div className="min-w-0 flex-1">
          <h1 className="truncate font-display text-[28px] leading-tight font-semibold tracking-tight">{title}</h1>
          {subtitle ? <p className="mt-1 truncate text-[15px] text-muted-foreground">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </header>
      {children}
    </div>
  );
}
